/**
 * The join code as a row of split-flap cells — the design's signature.
 *
 * The code is the product's most characteristic artifact: six unambiguous
 * characters that travel from the projector to every phone in the room, so it
 * is rendered as a designed object (departure-board tiles) everywhere it
 * appears, not as a string.
 */
export function CodeCells({
  code,
  size = 'md',
  flip = false,
}: {
  code: string;
  size?: 'sm' | 'md' | 'lg';
  /**
   * Plays the flap-in entrance, one cell after another. For a code the viewer
   * is seeing for the first time: the big screen putting one up, or the
   * builder opening a freshly duplicated poll under its new code.
   */
  flip?: boolean;
}) {
  return (
    <span
      className={`code-cells code-cells-${size}${flip ? ' code-cells-flip' : ''}`}
      role="img"
      aria-label={`Join code ${code.split('').join(' ')}`}
    >
      {code.split('').map((char, index) => (
        <span
          key={index}
          className="code-cell"
          aria-hidden="true"
          style={flip ? { animationDelay: `${index * 80}ms` } : undefined}
        >
          {char}
        </span>
      ))}
    </span>
  );
}
